import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-congrats-modal',
  templateUrl: './congrats-modal.component.html',
  styleUrls: ['./congrats-modal.component.scss']
})
export class CongratsModalComponent implements OnInit{
  bodyText = '';
  constructor(private readonly router: Router, public readonly ref: DynamicDialogRef, public readonly config: DynamicDialogConfig) { }

  ngOnInit(): void {
    this.bodyText = this.config.data.bodyText;
  }

  continue(): void {
    this.ref.close();
    this.router.navigate(["/"])
  }
}
